export const getToken = () => {
  return localStorage.getItem('apiToken');
}